import { httpRequest } from "@services/http";
import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import { LaunchNetworkConfigSerializer } from "@models/serializers/launchNetworkSerializer";

export class CommandSelectLaunchTemplate {
  async run(launchId: number, network: string, networkTemplateId: number): Promise<LaunchNetworkConfig> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/${network.toLowerCase()}/template/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify({ network_template_id: networkTemplateId }),
    });

    const serializer = new LaunchNetworkConfigSerializer();
    return serializer.deserialize(response);
  }
}
